"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALGOLIA_SYNC = exports.ALGOLIA_INDEX = void 0;
const client_1 = require("@apollo/client");
var ALGOLIA_INDEX;
(function (ALGOLIA_INDEX) {
    ALGOLIA_INDEX["Questions"] = "rebrand_questions";
    ALGOLIA_INDEX["Flashcards"] = "rebrand_cards";
    ALGOLIA_INDEX["Quesbook"] = "rebrand_quesbook";
    ALGOLIA_INDEX["OsceBook"] = "rebrand_oscebook";
    ALGOLIA_INDEX["PaceBook"] = "rebrand_pacebook";
    ALGOLIA_INDEX["Videos"] = "rebrand_videos";
})(ALGOLIA_INDEX = exports.ALGOLIA_INDEX || (exports.ALGOLIA_INDEX = {}));
exports.ALGOLIA_SYNC = (0, client_1.gql) `
  mutation AlgoliaSync($index: String!) {
    admin {
      algoliaSync(index: $index)
    }
  }
`;
